import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AddData: React.FC = () => {
    const [name, setName] = useState('');
    const [value, setValue] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        // Send data to the backend
        await fetch('https://appointments-api.quantinix.com/api/data', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name, value: Number(value) }),
        });

        // Redirect to the home page
        navigate('/');
    };

    return (
        <div>
            <h1>Add Data</h1>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>Name:</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Value:</label>
                    <input
                        type="number"
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        required
                    />
                </div>
                <button type="submit">Add Data</button>
            </form>
        </div>
    );
};

export default AddData;